export default __webpack_public_path__ + "static/media/ruslan.09ff8b7e.jpg";